export interface SanitizeOptions {
  multiline?: boolean;
  maxLength?: number;
  trim?: boolean;
}

// eslint-disable-next-line no-control-regex
const SINGLE_LINE_CONTROL_CHARS = /[\u0000-\u001F\u007F]/g;
// eslint-disable-next-line no-control-regex
const MULTILINE_CONTROL_CHARS = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g;

export const sanitizeInput = (value: unknown, options: SanitizeOptions = {}): unknown => {
  if (typeof value !== 'string') {
    return value;
  }

  const { multiline = false, maxLength, trim = true } = options;

  let result = value.replace(multiline ? MULTILINE_CONTROL_CHARS : SINGLE_LINE_CONTROL_CHARS, '');

  if (trim) {
    result = result.trim();
  }

  if (typeof maxLength === 'number' && result.length > maxLength) {
    result = result.slice(0, maxLength);
  }

  return result;
};

export const sanitizeFormValues = <T>(values: T, options: SanitizeOptions = {}): T => {
  if (Array.isArray(values)) {
    return values.map((item) => sanitizeFormValues(item, options)) as unknown as T;
  }

  if (values !== null && typeof values === 'object') {
    if (values instanceof Date) {
      return values;
    }

    const result: Record<string, unknown> = {};
    for (const [key, val] of Object.entries(values as Record<string, unknown>)) {
      result[key] = sanitizeFormValues(val, options);
    }
    return result as T;
  }

  return sanitizeInput(values, options) as T;
};
